import { useTracking } from '@change-corgi/core-react/tracking';

import type { StarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { craftStarterEmail } from '#src/app/shared/utils/decisionMaker';

type DecisionMaker = StarterDashboardV2PageData['petition']['decisionMakersConnection']['nodes'][number];

type Result = ModelHookResult<
	{ decisionMakers: Array<DecisionMaker & { emailHref?: string | null }> },
	{
		handleEmailClick: () => void;
	}
>;

export function useEmailDecisionMakerModalBody(): Result {
	const track = useTracking();

	const {
		data: {
			petition: {
				ask,
				slug,
				user: { displayName: starterDisplayName },
				signatureState: {
					signatureCount: { displayedLocalized: signatureCount },
				},
				decisionMakersConnection: { nodes: decisionMakers },
				emailDm,
			},
		},
	} = useStarterDashboardV2PageData();

	const withEmailHref = decisionMakers
		.filter((dm) => !!dm.email)
		.map((dm) => {
			const emailHref =
				dm.email &&
				craftStarterEmail({
					dmEmail: dm.email,
					dmName: dm.displayName,
					ask,
					slug,
					starterDisplayName,
					signatureCount,
					emailDm,
				});

			return {
				...dm,
				emailHref,
			};
		});

	const handleEmailClick = () => {
		void track('starter_dashboard_dm_list_email_click');
	};

	return {
		data: { decisionMakers: withEmailHref },
		actions: {
			handleEmailClick,
		},
	};
}
